import React from 'react';
import { DoneIcon, DoneAllIcon } from '@/components/ui/Icons';

export function MessageMeta({
  timeLabel,
  fileSizeLabel,
  showReadReceipts,
  readAt,
  deliveredAt,
  isOwn,
  variant = 'tail',
  inline = false,
  /** Ожидание подтверждения сервера (оптимистичное сообщение) — спиннер вместо галочек */
  deliveryPending,
  /** Пометка «ред.» если сообщение было отредактировано */
  edited,
}: {
  timeLabel?: string;
  /** Размер вложения (уже отформатированная строка), перед временем */
  fileSizeLabel?: string | null;
  showReadReceipts?: boolean;
  readAt?: string | null;
  deliveredAt?: string | null;
  isOwn?: boolean;
  /** tail — рядом с колонкой текста; corner — поверх изображения в правом нижнем углу */
  variant?: 'tail' | 'corner';
  inline?: boolean;
  deliveryPending?: boolean;
  edited?: boolean;
}): React.ReactNode {
  const corner = variant === 'corner';
  const receiptTitle = deliveryPending
    ? 'Отправка…'
    : readAt
      ? 'Прочитано'
      : deliveredAt
        ? 'Доставлено'
        : 'Сохранено на сервере';

  let receiptIcon: React.ReactNode = null;
  if (deliveryPending) {
    receiptIcon = <span className="chatAssistant__dmMetaPendingSpinner" aria-hidden />;
  } else if (readAt) {
    receiptIcon = <DoneAllIcon size={13} className="chatAssistant__dmReceipt_read" />;
  } else if (deliveredAt) {
    receiptIcon = <DoneAllIcon size={13} className="chatAssistant__dmReceipt_deliveredPeer" />;
  } else {
    receiptIcon = <DoneIcon size={13} className="chatAssistant__dmReceipt_saved" />;
  }

  return (
    <div
      className={`chatAssistant__dmMeta ${isOwn ? 'chatAssistant__dmMeta_own' : ''}${
        corner ? ' chatAssistant__dmMeta_cornerOnImage' : ''
      }${inline ? ' chatAssistant__dmMeta_inline' : ''}`}
    >
      {edited ? <span className="chatAssistant__dmMetaEdited">ред.</span> : null}
      {fileSizeLabel ? <span className="chatAssistant__dmMetaFileSize">{fileSizeLabel}</span> : null}
      {fileSizeLabel && timeLabel ? (
        <span className="chatAssistant__dmMetaSep" aria-hidden>
          {' '}
          ·{' '}
        </span>
      ) : null}
      {timeLabel ? <span>{timeLabel}</span> : null}
      {showReadReceipts && isOwn && (
        <span
          className="chatAssistant__dmMetaReceipt"
          title={receiptTitle}
          aria-label={deliveryPending ? 'Отправка сообщения' : undefined}
        >
          {receiptIcon}
        </span>
      )}
    </div>
  );
}
